import { createFileRoute } from "@tanstack/react-router";
import AdminSetClonePage from "@/pages/admin/sets/detail/clone";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/$setId/clone")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setId } = Route.useParams();
  const {
    userCanEditAllPrograms,
    userCanViewAllPrograms,
    userCanEditAllSets,
    userCanViewAllSets,
  } = useSetsPermissions();

  return (
    <AdminSetClonePage
      setId={Number(setId)}
      userCanEditAllPrograms={userCanEditAllPrograms}
      userCanViewAllPrograms={userCanViewAllPrograms}
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
    />
  );
}
